import { getDiffFromNow } from 'shared/utils/date-time';
import type { FeatureAdoptionData } from './featureAdoption.model';

export function featureAdoptionService<T>(params: Params) {
  const { storageItemName } = params;
  const MAX_VIEWS = 2;
  const _DEFAULT_VIEW_VALUE = 1;
  const _DEFAULT_LAST_SHOWN_VALUE = new Date().toISOString();

  const getStoredData = (): FeatureAdoptionData<T>[] => {
    const parsedItem = JSON.parse(
      localStorage.getItem(storageItemName) || '[]',
    );

    return parsedItem as FeatureAdoptionData<T>[];
  };

  const updateStoredData = (
    data: FeatureAdoptionData<T>[],
    stepsToUpdate?: T[],
  ) => {
    const storedData = data.map(val => {
      if (stepsToUpdate !== undefined && !stepsToUpdate.includes(val.type)) {
        return val;
      }
      let views = val.views;
      let lastShown = val.lastShown;
      if (hasDayElapsed(lastShown) && val.views < MAX_VIEWS) {
        views = MAX_VIEWS;
      }
      return {
        ...val,
        views,
        lastShown,
      };
    });
    localStorage.setItem(storageItemName, JSON.stringify(storedData));
  };

  const hasDayElapsed = (lastShown: string) => {
    const { hours } = getDiffFromNow(lastShown);
    return hours >= 24;
  };

  const initialAdoptionValue = (type: T) => ({
    type,
    views: _DEFAULT_VIEW_VALUE,
    lastShown: _DEFAULT_LAST_SHOWN_VALUE,
  });

  return {
    MAX_VIEWS,
    getStoredData,
    updateStoredData,
    hasDayElapsed,
    initialAdoptionValue,
  };
}

type Params = {
  storageItemName: string;
};
